module.exports = __webpack_public_path__ + "static/media/logo.0026b862.svg";